import clsx from 'clsx'
import {FC, PropsWithChildren, useMemo} from 'react'
import {HeaderProps} from 'react-table'
import {initialQueryState} from '../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../../core/QueryRequestProvider'
import {SiteModel} from '../../../core/_models'

type Props = {
  className?: string
  title?: any
  tableProps: PropsWithChildren<HeaderProps<any>>
}
const ActionCustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const id = tableProps.column.id

  return (
    <th>
      {title}
    </th>
  )
}

export {ActionCustomHeader}
